const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/services.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/services")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Service = TherapistServiceItem;